import type { RestaurantOnboardingState } from "@restlab/shared";
import { useEffect, useState, type ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { api } from "../api/client";
import { useAuth } from "../auth/AuthProvider";
import { LoadingState } from "./Page";

export function RestaurantOnboardingGate({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  const { locationId } = useParams();
  const location = useLocation();
  const [status, setStatus] = useState<
    "loading" | "complete" | "pending" | "unavailable"
  >("loading");
  const shouldCheck =
    Boolean(locationId) &&
    user?.role !== "super_admin" &&
    ["group_admin", "manager"].includes(user?.role ?? "") &&
    !location.pathname.endsWith("/onboarding");

  useEffect(() => {
    if (!shouldCheck) {
      setStatus("complete");
      return;
    }
    setStatus("loading");
    void api<RestaurantOnboardingState>(
      `/api/v1/locations/${locationId}/onboarding`,
    ).then(
      (state) => setStatus(state.complete ? "complete" : "pending"),
      () => setStatus("unavailable"),
    );
  }, [locationId, shouldCheck]);

  if (status === "loading") {
    return (
      <div className="page onboarding-gate-loader">
        <LoadingState rows={4} />
      </div>
    );
  }
  if (status === "pending") {
    return <Navigate to={`/locations/${locationId}/onboarding`} replace />;
  }
  return children;
}
